import React from 'react';

export const MobileMenu = (props) => (
    <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="20" cy="20" r="20"/>
        <path fill="#FFF" d="M29.1667 19.1667H10.8333C10.3731 19.1667 10 19.5398 10 20C10 20.4602 10.3731 20.8333 10.8333 20.8333H29.1667C29.6269 20.8333 30 20.4602 30 20C30 19.5398 29.6269 19.1667 29.1667 19.1667Z"/>
        <path fill="#FFF" d="M29.1667 13.3333H10.8333C10.3731 13.3333 10 13.7064 10 14.1667C10 14.6269 10.3731 15 10.8333 15H29.1667C29.6269 15 30 14.6269 30 14.1667C30 13.7064 29.6269 13.3333 29.1667 13.3333Z"/>
        <path fill="#FFF" d="M29.1667 25H10.8333C10.3731 25 10 25.3731 10 25.8333C10 26.2936 10.3731 26.6667 10.8333 26.6667H29.1667C29.6269 26.6667 30 26.2936 30 25.8333C30 25.3731 29.6269 25 29.1667 25Z"/>
    </svg>
)